/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderReceiptItemDto } from './orderReceiptItemDto';


export interface OrderReceiptDto { 
    footer?: string;
    header?: string;
    id?: number;
    kitchenName?: string;
    orderNo?: string;
    paymentDate?: string;
    prepareType?: OrderReceiptDto.PrepareTypeEnum;
    queueNo?: string;
    receiptItems?: Array<OrderReceiptItemDto>;
    receiptNo?: string;
    tableId?: number;
    tableName?: string;
}
export namespace OrderReceiptDto {
    export type PrepareTypeEnum = 'DINE_IN' | 'TAKE_AWAY';
    export const PrepareTypeEnum = {
        DineIn: 'DINE_IN' as PrepareTypeEnum,
        TakeAway: 'TAKE_AWAY' as PrepareTypeEnum
    };
}


